<template>
  <transition enter-active-class="transition-[opacity,transform] duration-300 ease-in"
              enter-from-class="opacity-0 scale-90"
              leave-active-class="transition-[opacity,transform] duration-200 ease-out"
              leave-to-class="opacity-0"
  >
    <slot></slot>
  </transition>
</template>

<script>
export default {
  name: "TransitionIconZoom",
  functional: true
}
</script>

<style scoped>

</style>